/** Cookie names and values must not contain separators or control characters. */
export function isSafeCookiePart(value: unknown): value is string {
    return (
        typeof value === 'string' &&
        value.length > 0 &&
        !Array.from(value).some((character) => {
            const codePoint = character.charCodeAt(0);
            return codePoint <= 31 || codePoint === 127 || character === ';' || character === ',';
        })
    );
}
